<template>
  <div class="d-flex align-center" :class="alignClass">
    <span class="mr-1">{{ text }}</span>
    <div class="d-inline-flex">
      <!-- Sort Button -->
      <v-btn
        v-if="sortable"
        icon
        small
        class="ma-0"
        @click="$emit('sort', value)"
        data-testid="header-cell__sort-btn"
      >
        <img v-if="sortKey !== value" src="/img/icons/ShortIcon.svg" alt="">
        <img v-else-if="sortDesc" src="/img/icons/ShortIcon.svg" alt="">
        <img v-else src="/img/icons/ShortIcon.svg" alt="">
      </v-btn>

      <!-- Filter Menu -->
      <v-menu
        v-if="filterable"
        v-model="menuOpen"
        :close-on-content-click="false"
        offset-y
        max-width="300"
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="ma-0"
            v-bind="attrs"
            v-on="on"
            :color="isActiveFilter ? 'primary' : ''"
            data-testid="header-cell__filter-btn"
          >
             <img v-if="!isActiveFilter" src="/img/icons/FilterIcon.svg" alt="">
             <v-icon small v-else>mdi-filter-menu</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-text class="pa-2">
            <v-text-field
              v-model="searchText"
              label="Search"
              dense
              hide-details
              outlined
              class="mb-2"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>

            <div class="filter-list scroll-y" style="max-height: 200px; overflow-y: auto;">
              <v-checkbox
                v-for="(option, index) in filteredOptions"
                :key="option"
                v-model="selectedValues"
                :label="option"
                :value="option"
                dense
                hide-details
                class="mt-1"
              ></v-checkbox>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn class="secondaryBtn" small @click="clearFilter">Clear</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="applyFilter">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderCell',
  props: {
    text: { type: String, required: true },
    value: { type: String, required: true },
    sortable: { type: Boolean, default: true },
    filterable: { type: Boolean, default: true },
    sortKey: { type: String, default: '' },
    sortDesc: { type: Boolean, default: false },
    filterOptions: { type: Array, default: () => [] }, // Array of strings
    currentFilters: { type: Array, default: () => [] },
    align: { type: String, default: 'left' } // left, center, right
  },
  data() {
    return {
      menuOpen: false,
      searchText: '',
      selectedValues: []
    };
  },
  watch: {
    menuOpen(val) {
      if (val) {
        // Reset local selection to prop value when menu opens
        this.selectedValues = [...this.currentFilters];
        this.searchText = '';
      }
    }
  },
  computed: {
    alignClass() {
      if (this.align === 'center') return 'justify-center';
      if (this.align === 'right') return 'justify-end';
      return 'justify-start'; // or space-between depending on layout preference
    },
    isActiveFilter() {
      return this.currentFilters && this.currentFilters.length > 0;
    },
    filteredOptions() {
      if (!this.searchText) return this.filterOptions;
      const search = this.searchText.toLowerCase();
      return this.filterOptions.filter(opt => 
        String(opt).toLowerCase().includes(search)
      );
    }
  },
  methods: {
    applyFilter() {
      this.$emit('filter', { key: this.value, values: this.selectedValues });
      this.menuOpen = false;
    },
    clearFilter() {
      this.selectedValues = [];
      this.applyFilter();
    }
  }
};
</script>

<style scoped>
.filter-list {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 4px;
}
</style>